import { render, staticRenderFns } from "./layout_sidebar.vue?vue&type=template&id=f04bffae&"
import script from "./layout_sidebar.vue?vue&type=script&lang=js&"
export * from "./layout_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./layout_sidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports